"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchFile = exports.fetchDeleteFile = exports.fetchDeleteEntity = exports.fetchUpdateEntity = exports.fetchCreateEntity = exports.fetchEntityList = exports.fetchEntityDetail = void 0;
const fetchHelpers_1 = require("./fetchHelpers");
const fetchEntityDetail = (url, mapApiToEntity) => {
    return (0, fetchHelpers_1.fetchToJson)(url)
        .then(response => response.data[0])
        .then((response) => mapApiToEntity(response));
};
exports.fetchEntityDetail = fetchEntityDetail;
const fetchEntityList = (url, mapApiToEntity) => {
    return (0, fetchHelpers_1.fetchToJson)(url)
        .then(response => response.data)
        .then((response) => response.map(item => mapApiToEntity(item)));
};
exports.fetchEntityList = fetchEntityList;
const fetchCreateEntity = (...params) => {
    return (0, fetchHelpers_1.fetchPostAction)(...params).then(value => value.data.max);
};
exports.fetchCreateEntity = fetchCreateEntity;
const fetchUpdateEntity = (...params) => {
    return (0, fetchHelpers_1.fetchPostAction)(...params);
};
exports.fetchUpdateEntity = fetchUpdateEntity;
const fetchDeleteEntity = (...params) => {
    return (0, fetchHelpers_1.fetchPostAction)(...params);
};
exports.fetchDeleteEntity = fetchDeleteEntity;
const fetchDeleteFile = (action, file, data, url, headerOptions) => {
    return (0, fetchHelpers_1.fetchPostAction)(action, {
        ...data,
        attach_id: file.attach_id,
        ulozeni: file.path
    }, url, headerOptions);
};
exports.fetchDeleteFile = fetchDeleteFile;
const fetchFile = (url) => {
    return (0, fetchHelpers_1.fetchToResponse)(url)
        .then(async (response) => {
        const blob = await response.blob();
        return {
            blob,
            filename: (0, fetchHelpers_1.getFilenameFromResponse)(response) ?? ""
        };
    });
};
exports.fetchFile = fetchFile;
